/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Overview_DescInputs */

const vi_camera_overview_desc = /** @type {(inputs: Camera_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ camera, kể cả camera chưa gắn vào đâu. Ảnh tự làm mới; bấm vào camera để xem trực tiếp.`)
};

/**

* @param {Camera_Overview_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_overview_desc = /** @type {((inputs?: Camera_Overview_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Overview_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_overview_desc(inputs)
});